// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"4acbe11a","453":"fe1f77df"}[chunkId] + ".chunk.js";
};